export const release = "05-NOV-26 04:32:01";
export const lemmonEnv: any = (globalThis as any).lemmonEnv;
